import React, { useEffect, useState } from "react";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import axios from "axios";
import { Switch } from "@mui/material";
import { BASE_URL, security_key } from "../../../global";
import { toast } from "react-toastify";
import LinearProgress from "@mui/material/LinearProgress";

function DraggableItem({
  item,
  index,
  onDragStart,
  onDragOver,
  onDragEnd,
  isActive,
  toggleActive,
}) {
  return (
    <div
      draggable
      onDragStart={(event) => onDragStart(event, index)}
      onDragOver={(event) => onDragOver(event, index)}
      onDrop={(event) => onDragEnd(event, index)}
      style={{
        backgroundColor: "white",
        padding: "10px",
        margin: "5px 0",
        cursor: "move",
        border: "1px solid #ccc",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>{item.cat_name}</span>
      <Switch
        checked={isActive}
        onChange={() => toggleActive(index)}
        inputProps={{ "aria-label": "controlled" }}
      />
    </div>
  );
}

function CategoryLandOrderTab({ handleClose, fetchAllCategory }) {
  const [categories, setCategories] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [activeStates, setActiveStates] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchAllNavCategory();
  }, []);

  const fetchAllNavCategory = async () => {
    const response = await axios.post(BASE_URL + "API/apicall", {
      security_key: security_key,
      mode: "getAllCategory",
    });

    const output = response.data;

    if (output.length > 0) {
      // setCategories(output);
      setCategories(output.sort((a, b) => a.cat_land_order - b.cat_land_order));
      setActiveStates(output.map((row) => row.cat_land_status));
    }
  };

  const handleDragStart = (event, index) => {
    setDraggedIndex(index);
    event.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnd = (event, index) => {
    event.preventDefault();
    const reorderedItems = [...categories];
    const [removed] = reorderedItems.splice(draggedIndex, 1);
    reorderedItems.splice(index, 0, removed);
    setCategories(reorderedItems);
    setDraggedIndex(null);
  };

  const toggleActive = (index) => {
    const updatedActiveStates = [...activeStates];
    updatedActiveStates[index] = !updatedActiveStates[index];
    setActiveStates(updatedActiveStates);
  };

  const handleSave = async () => {
    setIsSubmitting(true);
    const dataToSend = categories.map((category, index) => ({
      pk_cat_key: category.pk_cat_key,
      order_no: index + 1,
      visible_status: activeStates[index] ? 1 : 0,
    }));

    try {
      const response = await axios.post(BASE_URL + "API/apicall", {
        security_key: security_key,
        mode: "saveCategoryLandOrder",
        categories: dataToSend,
      });

      const output = response.data;

      if (output === 1) {
        handleClose();
        fetchAllCategory();
        toast.success("Updated successfully!", {
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error saving categories:", error);
    }

    setIsSubmitting(false);
  };

  return (
    <>
      <div className="modal-category">
        {categories.map((item, index) => (
          <DraggableItem
            key={item.pk_cat_key}
            item={item}
            index={index}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
            isActive={activeStates[index]}
            toggleActive={toggleActive}
          />
        ))}
      </div>
      <div className="text-end mt-3">
        <Button
          variant="outline-secondary"
          className="me-2"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSave} disabled={isSubmitting}>
          Save Order
          {isSubmitting && <LinearProgress />}
        </Button>
      </div>
    </>
  );
}

export default CategoryLandOrderTab;
